export default angular.module('installer.wizard-info', []).
  service('refreshWizardInfo', (wizardInfo, $http, installerConfig) => () => $http.get(`${installerConfig.backend.url }/wizard/info`).then(response => {
    angular.extend(wizardInfo, response.data);
    return response.data;
  }));



// WEBPACK FOOTER //
// ./src/blocks/wizard-info/wizard-info.js